import { z } from "zod";
import { JobSchema } from "./job";

const dateTransform = z.preprocess(
  (val) => (val ? new Date(val as string) : null),
  z.date().nullable()
);

export const InsuranceClaimSchema = z.object({
  icid: z.number(),
  icjid: z.number().nullable().optional(),
  icaid: z.number().nullable().optional(),
  icadid: z.number().nullable().optional(),
  icuid: z.number().nullable().optional(),
  icstatus: z.string().max(30).nullable().optional(),
  icdts: dateTransform,
  iclossdts: dateTransform,
  icdiscdts: dateTransform,
  icadjsched: dateTransform,
  icclaimnum: z.string().max(30).nullable().optional(),
  icpolicynum: z.string().max(30).nullable().optional(),
  icinsuranceco: z.string().max(100).nullable().optional(),
  icamount: z.number().nullable().optional(),
  icamountdts: dateTransform,
  icamountworking: z.number().nullable().optional(),
  icsimpleinspections: z.string().nullable().optional(),
  icadjatt: z.number().nullable().optional(),
  iccovsumrec: z.number().nullable().optional(),
  icinsupsub: z.number().nullable().optional(),
  icsufcovapp: z.number().nullable().optional(),
  icdenied: z.number().nullable().optional(),
  job: z.object(JobSchema.shape).nullable().optional()
});

// Create schemas (omit auto-generated fields)
export const CreateInsuranceClaimSchema = InsuranceClaimSchema.omit({ icid: true });

// Update schemas (make all fields optional except ID)
export const UpdateInsuranceClaimSchema = InsuranceClaimSchema.partial().required({ icid: true });

// Type definitions
export type InsuranceClaim = z.infer<typeof InsuranceClaimSchema>;
export type CreateInsuranceClaim = z.infer<typeof CreateInsuranceClaimSchema>;
export type UpdateInsuranceClaim = z.infer<typeof UpdateInsuranceClaimSchema>; 